// extracted by mini-css-extract-plugin
module.exports = {"innerBanner":"InnerBanner_innerBanner__2PhA_","bannerTitle":"InnerBanner_bannerTitle__cRv2D"};